import { createContext } from "react";

export const ReimbursementStatusBarExpandedContext = createContext(false);
